import { render, staticRenderFns } from "./UpdateMember.vue?vue&type=template&id=28a5c605&"
import script from "./UpdateMember.vue?vue&type=script&lang=js&"
export * from "./UpdateMember.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMember.vue?vue&type=style&index=0&id=28a5c605&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports